<template>
	<component class="tt638" :is="tag">
		<slot></slot>
	</component>
</template>

<script>
export default {
	name: "j-text",
	props: {
		tag: {
			type: String,
			required: false,
			default: "p"
		}
	}
}
</script>
<style src="./index.css" scoped />
